module.exports = __webpack_public_path__ + "static/favicon-128-d4f444fd28fef55b8bae35b518ff3ad4.png";